import {
  Outlet,
  Route,
  useLoaderData,
  useNavigate,
  useRouteError,
} from "react-router-dom";
import "./styles.css";
import GenericErrorDisplay from "../../generic-error";

import * as PageIndex from "./page-index";
import * as PageLc from "./page-lc";
import ResourceService from "../../../service/resource";
import OutputResource from "../../../dtos/resource";
import ResourceDisplay from "../../../components/resource-display";
import { PublicLc } from "../../../dtos/lc";
import PublicCongress from "../../../dtos/congress";
import LcService from "../../../service/lc";
import CongressService from "../../../service/congress";
import PinMap, { MapPin, MapPinGroup } from "../../../components/pin-map";
import { IMAGE_HOST } from "../../../server/config";
import STYLES_CONSTANTS from "../../../styles";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import { useRef } from "react";
import CongressesContext from "./context";

export const path = "congresses/";

const resourceKeys = {
  header: "opportunities-congresses-header",
  title: "opportunities-index-section-congresses-title",
  description: "opportunities-congresses-description",
  map: "transmed-page-RomaniaMoldova",
};

type LoaderType = [
  { [key: string]: OutputResource },
  PublicLc[],
  PublicCongress[],
];

export async function loader(): Promise<LoaderType> {
  const resources = new ResourceService().read.byIds(
    Object.values(resourceKeys),
  );

  const lcs = new LcService().read.all();
  const congresses = new CongressService().read.all();

  return [await resources, await lcs, await congresses];
}

export function Component() {
  const [resources, lcs, congresses] = useLoaderData() as LoaderType;
  const navigate = useNavigate();
  const dimensions = useWindowDimensions();
  const outletRef = useRef<HTMLDivElement>(null);

  return (
    <div id="page-oportunitati-congresses">
      <section className="header">
        <ResourceDisplay
          resource={resources[resourceKeys.header]}
          className="background"
        />
        <ResourceDisplay
          resource={resources[resourceKeys.title]}
          wrapper="h1"
          className="title"
        />
      </section>
      <ResourceDisplay
        resource={resources[resourceKeys.description]}
        className="description content-container"
      />
      <section className="map content-container">
        <PinMap
          map={IMAGE_HOST + resources[resourceKeys.map].value}
          pins={lcs
            .filter((lc) =>
              congresses.map((congress) => congress.lc).includes(lc.id),
            )
            .map(
              (lc) =>
                new MapPinGroup(
                  lc.city,
                  [
                    new MapPin(
                      "",
                      parseInt(
                        (
                          STYLES_CONSTANTS["--color-fasmr-blue"] as string
                        ).slice(1),
                        16,
                      ),
                      () => {
                        navigate(`${lc.id}/`, {
                          preventScrollReset: true,
                        });

                        outletRef.current?.scrollIntoView();
                        window.scrollBy(0, dimensions.height * -0.4);
                      },
                    ),
                  ],
                  lc.map_x,
                  lc.map_y,
                ),
            )}
        />
      </section>
      <div ref={outletRef} />
      <CongressesContext.Provider value={{ lcs, congresses }}>
        <Outlet />
      </CongressesContext.Provider>
    </div>
  );
}
Component.displayName = "page-oportunitati-congresses";

export function ErrorBoundary() {
  const error = useRouteError();
  return <GenericErrorDisplay error={error} />;
}
ErrorBoundary.displayName = "page-oportunitati-congresses-error";

export const children = [<Route index {...PageIndex} />, <Route {...PageLc} />];
